module.exports = __webpack_public_path__ + "static/Robert-Hodges2-4f465a4d8850bba8bf831b5db0179334.jpg";